import React from 'react';
import certifications from '../../api/certifications.json'; // Assuming JSON for certifications

const Certifications = () => {
  return (
    <div className="certifications-page text-light p-5">
      <ul className="list-unstyled">
        {certifications.map((cert, index) => (
          <li key={index} className="mb-3">
            <a
              href={cert.link}
              target="_blank"
              rel="noopener noreferrer"
              className="cert-link text-decoration-none d-flex align-items-center gap-2"
            >
              {/* Link Icon */}
              <i className="bi bi-box-arrow-up-right"></i>

              {/* Certification Title */}
              <span className="fs-6">{cert.title}</span>
            </a>
            <p className="text-muted small mb-0">{cert.institution}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Certifications;
